import { forwardRef } from 'react';

import PhoneNumberInlineField from 'components/Fields/InlineTableFieldInput/PhoneNumber';
import { withCellWrapper } from './helpers';

const _PhoneNumberCell = forwardRef(
  (
    {
      field,
      entityId,
      entityAccess,
      onSubmit,
      value,
      objectId,
      serviceToUse,
      fetchUrl,
      handleUpdateFieldOption,
      handleUpdateTableRecords,
      menuLeftButton,
      menuRightButton,
      placeholder,
      adornments = [],
      info,
      showDisplayNameTooltip,
      column,
      readOnly,
      onAutoFocus,
      ...others
    },
    ref
  ) => {
    const {
      // instead fetch default country from redux - we have it in the field defaultRegion
      // chosenBusiness.phone_default_region === defaultRegion
      phonenumberOptions: { enableExtension, defaultRegion },
    } = field;
    const phoneAdornments = adornments.filter(
      (adornment) => adornment.field_type !== 'phone_number'
    );
    return (
      <PhoneNumberInlineField
        ref={ref}
        {...others}
        value={
          value?.formatted ||
          value?.formattedNationalNumber ||
          value?.formatted_national_number ||
          value?.e164 ||
          value ||
          ''
        }
        onSubmit={onSubmit}
        readOnly={readOnly}
        onAutoFocus={onAutoFocus}
        enableExtension={enableExtension}
        defaultCountry={defaultRegion}
        field={field}
        objectId={objectId}
        entityId={entityId}
        adornments={phoneAdornments}
      />
    );
  }
);

export const PhoneNumberCell = withCellWrapper(_PhoneNumberCell);
